import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './ElevateSlider.css';

// Import your icon images
import icon1 from '../assets/images/elevate1.png';
import icon2 from '../assets/images/elevate2.png';
import icon3 from '../assets/images/elevate3.png';

const ElevateSlider = ({ sliders = [] }) => {
  // Helper function to format numbers (e.g., 2000000 -> 2M, 150000 -> 150K, 2000 -> 2K)
  const formatNumber = (numStr) => {
    const num = parseFloat(numStr);
    if (isNaN(num)) return numStr; // Return original string if not a number

    if (num >= 1_000_000_000) {
      return `${(num / 1_000_000_000).toFixed(0)}B+`;
    } else if (num >= 1_000_000) {
      return `${(num / 1_000_000).toFixed(0)}M+`;
    } else if (num >= 1_000) {
      return `${(num / 1_000).toFixed(0)}K+`;
    }
    return num.toString();
  };

  // Default slider items to use if no sliders are provided
  const defaultSliderItems = [
    {
      img: icon1,
      number: '17M+',
      text: 'Happy Users',
    },
    {
      img: icon2,
      number: '17M+',
      text: 'Happy Users',
    },
    {
      img: icon3,
      number: '17M+',
      text: 'Happy Users',
    },
  ];

  // Use provided sliders if available, otherwise use defaults
  const sliderItems = sliders.length > 0
    ? sliders.map(slider => ({
        img: slider.image || icon1,
        number: formatNumber(slider.title) || '0', // Apply formatting to title
        text: slider.description || 'Description not available',
      }))
    : defaultSliderItems;

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const CustomPrevArrow = (props) => (
    <button
      {...props}
      className="slick-prev custom-arrow"
      aria-label="Previous"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="currentColor" />
      </svg>
    </button>
  );

  const CustomNextArrow = (props) => (
    <button
      {...props}
      className="slick-next custom-arrow"
      aria-label="Next"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" fill="currentColor" />
      </svg>
    </button>
  );

  return (
    <div className="elevate-slider-container">
      <Slider {...settings} prevArrow={<CustomPrevArrow />} nextArrow={<CustomNextArrow />}>
        {sliderItems.map((item, index) => (
          <div className="stat-item" key={index}>
            <div className="stat-icon">
              <img src={item.img} alt={`icon-${index}`} className="slider-icon-img" loading="lazy" />
            </div>
            <div className="stat-content">
              <h3 className="stat-number">{item.number}</h3>
              <p className="stat-text">{item.text}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ElevateSlider;